import { JobList } from "./JobList";
import { JobShow } from "./JobShow";

export default {
  list: JobList,
  show: JobShow,
};
